<div class="searchbox">
  <div id="autocomplete"></div>

  <ais-configure [searchParameters]="searchParameters"></ais-configure>
  <div>
    <mat-form-field class="seachContainerField">
      <mat-icon aria-hidden="false" aria-label="seach icon" matPrefix
        >search</mat-icon
      >
      <input
        matInput
        [matAutocomplete]="auto"
        (keyup)="handleChange($event)"
        style="width: 100%"
        id="seach"
        placeholder="Seach..."
        class="seach-input"
      />
    </mat-form-field>
    <mat-autocomplete
      #auto="matAutocomplete"
      style="margin-top: 30px; max-height: 600px"
    >
      <mat-optgroup
        *ngFor="let index of state.indices || []"
        [label]="index.index"
      >
        <mat-option
          *ngFor="let option of index.hits"
          [value]="option.title"
          (click)="goToDetailService(option)"
          class="aa-ItemLink mb-2 mt-2"
        >
          <div class="aa-ItemContent specialContent pb-1 pt-1">
            <div class="aa-ItemIcon">
              <img
                *ngIf="option.serviceImage"
                [src]="option.serviceImage | sanitize"
                [alt]="option.title"
              />
              <img
                *ngIf="!option.serviceImage || option.serviceImage === ''"
                src="assets/img/no-image.svg"
                [alt]="option.title"
              />
            </div>
            <div class="aa-ItemContentBody specialBody">
              <div class="aa-ItemContentTitle">
                {{ option.title }}
              </div>
            </div>
          </div>
        </mat-option>
      </mat-optgroup>
    </mat-autocomplete>
  </div>
</div>
